import { Title } from "@vshp/ui-components";
import CustomSlider from "../utils/Slider";

const PageImages = ({ title, images }) => {
  const settings = {
    arrows: false,
    adaptiveHeight: false,
  };

  const imageList = Array.isArray(images) ? images : [];

  return (
    <>
      {title !== null && title.length > 0 && <Title type="h2">{title}</Title>}
      {imageList.length > 1 ? (
        <>
          <CustomSlider className="slider__dots_blue" sliderSettings={settings}>
            {imageList.map((item, key) => {
              return (
                <div className="slider__item" key={key}>
                  <figure>
                    <img src={item.image} alt="" />
                    <figcaption>{item.content ?? ""}</figcaption>
                  </figure>
                </div>
              );
            })}
          </CustomSlider>
        </>
      ) : (
        imageList.map((item, key) => {
          return (
            <figure key={key}>
              <img src={item.image} alt="" />
              <figcaption>{item.content ?? ""}</figcaption>
            </figure>
          );
        })
      )}
    </>
  );
};

export default PageImages;
